import { i18n } from '../../i18n';
import { getSavedFilters } from '../../hooks';
import {
  momentTextFormat,
  showToRoles,
  filterWithUserId,
  formatContainerType,
  exportExcel,
} from '../../utils';
import { gateOutsService } from '../../services';

export const handleExportExcelClick = async ({
  states,
  user,
  filteredStates,
  totalCount,
  sortField,
  sortDirection,
}: any) => {
  const oldFilters = getSavedFilters('belongs-to');
  let fileName = 'GATE-OUTS';
  if (oldFilters.yardName) fileName += `__${oldFilters.yardName}`;
  if (oldFilters.clientName) fileName += `__${oldFilters.clientName}`;
  let startDate = states.startDate ? momentTextFormat(states.startDate, user, true) : '';
  let endDate = states.endDate ? momentTextFormat(states.endDate, user, true) : '';

  const { data } = await gateOutsService
    .getAllPreFormatProps({
      params: {
        ...filterWithUserId({ ...filteredStates }, user),
        take: totalCount,
        skip: 0,
        sortField,
        sortDirection,
      },
    })
    .then((res) => res.data);

  const excelData = data.map((container: any) => ({
    [i18n.t('common.client')]: showToRoles('adminRead', user)
      ? container.clientYard?.client?.code
      : '',
    [i18n.t('label.containerNumber')]: container.number,
    [i18n.t('label.type')]: formatContainerType(container.type),
    [i18n.t('label.status')]: container.gateOut.status,
    [i18n.t('label.createdAt')]: container.gateOut.createdAt
      ? momentTextFormat(container.gateOut.createdAt, user)
      : '',
    [i18n.t('label.completedAt')]:
      (states.status === 'COMPLETED' || states.status === 'All') && container.gateOut.completedAt
        ? momentTextFormat(container.gateOut.completedAt, user)
        : '',
    [i18n.t('label.gateOutDateFrom')]: container.gateOut.validFrom
      ? momentTextFormat(container.gateOut.validFrom, user)
      : (states.status === 'All' || states.status === 'COMPLETED') && container.gateOut.createdAt
      ? momentTextFormat(container.gateOut.createdAt, user)
      : '',
    [i18n.t('label.gateOutDateTo')]: container.gateOut.validTo
      ? momentTextFormat(container.gateOut.validTo, user)
      : (states.status === 'All' || states.status === 'COMPLETED') && container.gateOut.completedAt
      ? momentTextFormat(container.gateOut.completedAt, user)
      : '',
    [i18n.t('label.licensePlateNumber')]:
      states.status === 'COMPLETED' ? container.gateOut.driver?.licensePlateNumber : '',
  }));

  const filters = [
    {
      [i18n.t('label.country')]: states.country,
      [i18n.t('label.city')]: states.city,
      [i18n.t('common.yard')]: oldFilters.yardName ?? '',
      [i18n.t('common.client')]: oldFilters.clientName ?? '',
      [i18n.t('label.containerNumber')]: states.containerNumber,
      [i18n.t('label.containerType')]: formatContainerType(states.containerType),
      [i18n.t('label.licensePlateNumber')]: states.licensePlateNumber,
      [i18n.t('label.status')]: states.status,
      [i18n.t('label.from')]: startDate ?? '',
      [i18n.t('label.to')]: endDate ?? '',
    },
  ];

  const sheets = [
    { data: excelData, sheetName: i18n.t('pages.gateOuts.sheet.gateOuts') },
    { data: filters, sheetName: i18n.t('pages.gateOuts.sheet.filters') },
  ];

  if (startDate || endDate) {
    startDate = startDate || 'start';
    endDate = endDate || momentTextFormat(new Date(), user, true);
    fileName = `${fileName} ${startDate}__${endDate}`;
  }

  exportExcel({ sheets, fileName });
};
